import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { IQualityCheckResult } from "libraries/service/resources/booking/bookingResource.service";
import { NotificationType } from "libraries/interfaces/INotification";
import { Yii } from "libraries/interfaces/Yii";

/**
 * Displays quality check result. Success card if all checks passed, warning card if one or more check failed.
 */
@Component({
    selector: 'quality-check-result',
    template: `
        <notification *ngIf="isSuccess" mode='bodyOnly'
                      [type]="notificationType.Success"
                      [showCloseButton]="showCloseButton"
                      (onClose)="closeNotification()">
            {{ qualityCheckMessages.succeeded }}
        </notification>
        <notification *ngIf="hasWarnings"
                      [type]="notificationType.Warning"
                      [showCloseButton]="showCloseButton"
                      (onClose)="closeNotification()">
            <ng-container *ngFor="let result of qualityCheckResults">
                <ng-container *ngIf="!result.match">
                    <h3>{{result.label}}</h3>
                    <ul>
                        <li *ngFor="let message of result.message" [innerHTML]="message"></li>
                    </ul>
                </ng-container>
            </ng-container>
        </notification>
    `
})
export class QualityCheckResultComponent implements OnChanges {

    @Input()
    public showTitle?: boolean;

    @Input()
    public showCloseButton?: boolean;

    @Input()
    public qualityCheckResults?: IQualityCheckResult[];

    public readonly qualityCheckMessages: { succeeded: string; resultWithMessages: string } = {
        succeeded: Yii.t('wui-shared-js', 'Aucune erreur relevée lors du contrôle qualité.'),
        resultWithMessages: Yii.t('wui-shared-js', 'Contrôle qualité :')
    };

    public notificationType: typeof NotificationType = NotificationType;

    public hasWarnings: boolean = false;
    public isSuccess: boolean = false;

    public ngOnChanges(changes: SimpleChanges): void {
        this.hasWarnings = this.qualityCheckResults && this.qualityCheckResults.some((value: IQualityCheckResult) => !value.match);
        this.isSuccess = this.qualityCheckResults && this.qualityCheckResults.every((value: IQualityCheckResult) => value.match);
    }

    public closeNotification(): void {
        this.qualityCheckResults = null;
    }
}
